  
  import React from "react";

  
  const PrivacyPolicy = () => {

  return (
        <div className="xl:px-[calc((100%-1250px)/2)] px-3 mt-60 mb-20">
      <h1 className="text-3xl font-bold text-[#2A668D] mb-4">Privacy Policy</h1>
      <p className="mb-4">
        Wehelpufirst values your privacy. This privacy policy outlines how we collect,
        use, and protect your information.
      </p>

      <ol className="list-decimal ml-6 space-y-2">
        <li>
          <strong>Data Collection:</strong> We collect personal information such as your
          name, email, phone number, and location during registration and service use.
        </li>
        <li>
          <strong>Usage:</strong> We use your information to improve our services, contact
          you about updates, and provide support.
        </li>
        <li>
          <strong>Third-Party Sharing:</strong> We do not sell your data. Data may be
          shared with vendors only to facilitate services.
        </li>
        <li>
          <strong>Security:</strong> We implement best practices to safeguard your data
          using encryption and secure servers.
        </li>
      </ol>

      <p className="mt-6">
        By using our platform, you consent to the practices described in this policy.
        For concerns, please contact us.
      </p>
    </div>
  );
};
export default PrivacyPolicy;